// Render-time HTML sanitiser for anything the app authored via the
// Tiptap editor (event & template descriptions today). The backend
// already sanitises on write with `nh3`, so this is defence in depth
// against a stored payload that slipped in before the backend rule
// existed, or from a rogue API client.
import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "u", "ul", "ol", "li",
  "h1", "h2", "h3", "a", "span",
];

const ALLOWED_ATTR = ["href", "title", "target", "rel", "style"];

export function sanitizeRichText(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Force any external link opened in a new tab to go through
    // rel="noopener noreferrer" so the target can't reach back into
    // window.opener.
    ADD_ATTR: ["target"],
  });
}
